import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeReportingToService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { }
  

  EmployeeReportingToSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReportingTo/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ReportingToEmployee(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeReporting/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ReportingToClient(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReportingToClient/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ReportingToSite(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReportingToSite/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ReportingToBranch(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReportingToBranch/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ReportingToCompany(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReportingToCompany/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ReportingToRegion(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ReportingToRegion/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
